import React, { useState } from 'react';
import { Button, ButtonGroup, Dropdown, Spinner } from 'react-bootstrap';
import { exportToPdf } from '../utils/pdfExporter';
import type { ParsedElement } from '@/pages/ActualDocumentPage';

interface ExportPanelProps {
  elements: ParsedElement[];
  docName: string;
  docPassing?: string;
  docNumber?: string;
}

export const ExportPanel: React.FC<ExportPanelProps> = ({
  elements,
  docName,
  docPassing,
  docNumber,
}) => {
  const [exporting, setExporting] = useState(false);

  const handlePdfExport = async () => {
    setExporting(true);
    try {
      const subtitle = [docPassing, docNumber ? `№ ${docNumber}` : '']
        .filter(Boolean)
        .join(', ');

      await exportToPdf(elements, {
        filename: `${docName.replace(/[^\w\s-]/g, '').slice(0, 50)}.pdf`,
        title: docName,
        subtitle,
      });
    } catch (err) {
      console.error('PDF export failed:', err);
      alert('Ошибка экспорта в PDF');
    } finally {
      setExporting(false);
    }
  };

  return (
    <ButtonGroup>
      <Dropdown>
        <Dropdown.Toggle variant="outline-light" size="sm" disabled={exporting}>
          {exporting ? (
            <><Spinner animation="border" size="sm" className="me-1" />Экспорт...</>
          ) : (
            <><i className="bi bi-download me-1"></i>Экспорт</>
          )}
        </Dropdown.Toggle>
        <Dropdown.Menu>
          <Dropdown.Item onClick={handlePdfExport}>
            <i className="bi bi-file-earmark-pdf me-2 text-danger"></i>PDF
          </Dropdown.Item>
          <Dropdown.Item disabled>
            <i className="bi bi-file-earmark-word me-2 text-primary"></i>DOCX (скоро)
          </Dropdown.Item>
          <Dropdown.Item disabled>
            <i className="bi bi-file-earmark-text me-2 text-success"></i>TXT (скоро)
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>
    </ButtonGroup>
  );
};